module.exports = __webpack_public_path__ + "static/tg_mini-d590f6d23df035f5b689dfbdf183cca8.png";